import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";

import {
  OnlinetvHero,
  OnlinetvPopular,
  OnlinetvMoreVideo,
} from "@modules/study/onlinvtv/home";

const OnlineTv = () => {
  return (
    <LayoutMain
      title={`Online tv`}
      name="description"
      content="Apply to Universities Abroad with expert guidance from existing students"
    >
      <OnlinetvHero />
      <OnlinetvPopular />
      <OnlinetvMoreVideo />
    </LayoutMain>
  );
};

export default OnlineTv;
